import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IUserActionLogFilterOptions } from '../interfaces/Invoice/iuser-action-log-filter-options';
import { IUserActionLogRowVo } from '../interfaces/Invoice/iuser-action-log-row-vo';
import { IUserActionLogSearchRequest } from '../interfaces/Invoice/iuser-action-log-search-request';

@Injectable({
  providedIn: 'root'
})
export class UserActionLogService {
  private apiUrl = '';

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.apiUrl = baseUrl;
  }

  search(request: IUserActionLogSearchRequest): Observable<IUserActionLogRowVo[]> {
    const headers = { 'content-type': 'application/json' };
    const url = this.apiUrl + 'api/UserActionLog/Search';
    return this.http.post<IUserActionLogRowVo[]>(url, request, { headers: headers });
  }

  getFilterOptions(pharmacyId: number | null): Observable<IUserActionLogFilterOptions> {
    let url = this.apiUrl + 'api/UserActionLog/FilterOptions';
    if (pharmacyId != null) {
      url += '?pharmacyId=' + encodeURIComponent(String(pharmacyId));
    }
    return this.http.get<IUserActionLogFilterOptions>(url);
  }
}
